import React from 'react';

import {
  Title,
  Paper,
  Stack,
  Group,
  Button
} from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { useNavigate } from 'react-router-dom';

import ClientForm from '../components/client/ClientForm';

const AddClient: React.FC = () => {
  const navigate = useNavigate();

  const handleSuccess = () => {
    notifications.show({
      title: 'Success',
      message: 'Client added successfully',
      color: 'green'
    });
    void navigate('/clients');
  };

  const handleCancel = () => {
    void navigate('/clients');
  };

  return (
    <Stack gap="md">
      <Group align="center" justify="space-between">
        <Title order={1}>Add New Client</Title>
        <Button variant="outline" onClick={() => void navigate('/clients')}>
          Back to All Clients
        </Button>
      </Group>

      <Paper withBorder p="xl">
        <Stack gap="lg">
          <ClientForm
            mode="add"
            onCancel={handleCancel}
            onSuccess={handleSuccess}
          />
        </Stack>
      </Paper>
    </Stack>
  );
};

export default AddClient;
